import { render, staticRenderFns } from "./DisplayPriorityIframe.vue?vue&type=template&id=0390ff8c&"
import script from "./DisplayPriorityIframe.vue?vue&type=script&lang=ts&"
export * from "./DisplayPriorityIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports